export default __webpack_public_path__ + "static/media/transition-3.e79a25e0.mp3";